var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrailerSlipAway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 110,
    viewBox: "0 0 111 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.507812,
    width: 110,
    height: 110,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 43.0219C35.6625 43.0219 37 44.3615 37 46.0267V58.0459C37 59.7111 35.6625 61.0507 34 61.0507C32.3375 61.0507 31 59.7111 31 58.0459V46.0267C31 44.3615 32.3375 43.0219 34 43.0219ZM46 43.0219C47.6625 43.0219 49 44.3615 49 46.0267V58.0459C49 59.7111 47.6625 61.0507 46 61.0507C44.3375 61.0507 43 59.7111 43 58.0459V46.0267C43 44.3615 44.3375 43.0219 46 43.0219ZM58 43.0219C59.6625 43.0219 61 44.3615 61 46.0267V64.0555C61 65.7207 59.6625 67.0604 58 67.0604C56.3375 67.0604 55 65.7207 55 64.0555V46.0267C55 44.3615 56.3375 43.0219 58 43.0219ZM70 43.0219C71.6625 43.0219 73 44.3615 73 46.0267V64.0555C73 65.7207 71.6625 67.0604 70 67.0604C68.3375 67.0604 67 65.7207 67 64.0555V46.0267C67 44.3615 68.3375 43.0219 70 43.0219ZM41 89.0956C34.2625 89.0956 29 83.712 29 77.0764H25C20.5813 77.0764 17 73.4831 17 69.0636V41.0187C17 36.5928 20.5813 33.0059 25 33.0059H79C83.4125 33.0059 87 36.5928 87 41.0187V71.0668H94C95.6625 71.0668 97 72.4064 97 74.0716C97 75.7367 95.6625 77.0764 94 77.0764H53C53 83.712 47.625 89.0956 41 89.0956ZM25 39.0155C23.895 39.0155 23 39.9119 23 41.0187V69.0636C23 70.1653 23.895 71.0668 25 71.0668H30.6C32.675 67.4735 36.5625 65.0571 41 65.0571C45.4375 65.0571 49.325 67.4735 51.4 71.0668H81V41.0187C81 39.9119 80.1 39.0155 79 39.0155H25ZM41 71.0668C37.6875 71.0668 35 73.7586 35 77.0764C35 80.3942 37.6875 83.086 41 83.086C44.3125 83.086 47 80.3942 47 77.0764C47 73.7586 44.3125 71.0668 41 71.0668Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailerSlipAway);
export default __webpack_public_path__ + "static/media/trailerSlipAway.18a9a847aa5a72f3c371246f2f4a83c0.svg";
export { ForwardRef as ReactComponent };